import React, {useState} from 'react'
import "./qualification.css"

const Qualification = () => {
    const [toggleState, setToggleState] = useState (1)

    const toggleTab = (index) => {
        setToggleState(index);
    };

  return (
    <section className='qualification section'>
        <h2 className='section__title'>Qualification</h2>
        <span className='section__subtitle'>My Personal Journey</span>

        <div className='qualification__container container'>
            <div className='qualification__tabs'>
                <div className={toggleState === 1 ? "qualification__button qualification__active button--flex":"qualification__button qualification__active button--flex"}
                onClick={() => {
                    toggleTab(1)
                }}
                >
                    <i className='uil uil-graduation-cap qualification__icon'></i> {" "} Education 
                </div>

                <div className={toggleState === 2 ? "qualification__button qualification__active button--flex":"qualification__button qualification__active button--flex"}
                onClick={() => {
                    toggleTab(2)
                }}
                >
                    <i className='uil uil-briefcase-alt qualification__icon'></i> {" "} Experience
                </div>
            </div>

            <div className='qualification__sections'>
                <div className={toggleState === 1 ? 'qualification__content qualification__content-active': 'qualification__content qualification__content'}>
                    <div className='qualification__data'>
                        <div>
                            <h3 className='qualification__title'>Basic Schooling</h3>
                            <span className='qualification__subtitle'> 
                            Bhatikar Model School
                            </span>
                            <div className='qualification__calendar'>
                                <i className='uil uil-calendar-alt'></i> 2008 - 2012
                            </div>
                        </div>

                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                    </div>

                    <div className='qualification__data'>
                        <div></div>
                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                        <div>
                            <h3 className='qualification__title'>Class 10th</h3>
                            <span className='qualification__subtitle'> 
                            Bhatikar Model High School
                            </span>
                            <div className='qualification__calendar'>
                                <i className='uil uil-calendar-alt'></i> 2012 - 2016
                            </div>
                        </div>
                    </div>

                    <div className='qualification__data'>
                        <div>
                            <h3 className='qualification__title'>Class 12th</h3>
                            <span className='qualification__subtitle'> 
                            Shree Damodar Higher Secondary School
                            </span>
                            <div className='qualification__calendar'>
                                <i className='uil uil-calendar-alt'></i> 2018 - 2020
                            </div>
                        </div>

                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                    </div>

                    <div className='qualification__data'>
                        <div></div>
                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                        <div>
                            <h3 className='qualification__title'>Graduation</h3>
                            <span className='qualification__subtitle'> 
                            Padre Conceicao College Of Engineering
                            </span>
                            <div className='qualification__calendar'>
                                <i className='uil uil-calendar-alt'></i> 2020 - Present
                            </div>
                        </div>
                    </div>
                </div>

                <div className={toggleState === 2 ? 'qualification__content qualification__content-active': 'qualification__content qualification__content'}>
                    <div className='qualification__data'>
                        <div>
                            <h3 className='qualification__title'>Graphic Designer</h3>
                            <span className='qualification__subtitle'> 
                            Smilekeepers Foundation
                            </span>
                            <div className='qualification__calendar'>
                                <i className='uil uil-calendar-alt'></i> 2022
                            </div>
                        </div>

                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                    </div>

                    <div className='qualification__data'>
                        <div></div>
                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                        <div>
                            <h3 className='qualification__title'>Web Developer</h3>
                            <span className='qualification__subtitle'> 
                            Flashlab Creative
                            </span>
                            <div className='qualification__calendar'>
                                <i className='uil uil-calendar-alt'></i> 2023
                            </div>
                        </div>
                    </div>

                    <div className='qualification__data'>
                        <div>
                            <h3 className='qualification__title'>Web Developer</h3>
                            <span className='qualification__subtitle'> 
                            Insights Media
                            </span>
                            <div className='qualification__calendar'>
                                <i className='uil uil-calendar-alt'></i> 2023 - Present
                            </div>
                        </div>

                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Qualification